import {ExternalSSP, YaMobileFloorBanner, YandexFloorAd} from '@shared/Ads';
import {safeLocalStorage} from '@utils/safeStorages';
import {useEnvConfig} from '@web-catalog/env';
import {getEnvConfig} from '@web-catalog/env';
import {useEffect, useState} from 'react';
import {UAParser} from 'ua-parser-js';
import {v4} from 'uuid';

import {SSP_USER_ID} from '@web-catalog/components/Ads/SSP/consts';

import {useGetCurrentAppPackageName} from '@web-catalog/hooks';
import {useOmicronClientFlag} from '@web-catalog/hooks/omicron';

import {
  authDoneStates,
  useAuthorizedProfile,
  useAuthProgressState,
  useGetVkId,
} from '@web-catalog/store/auth';

import {emitYmEvent, logTmrEvent} from '@web-catalog/utils/analytics';

import {AuthDoneGate} from '../Auth/AuthDoneGate';
import {SSP} from './SSP';

export const MultiProviderFloorAd = () => {
  const yandexAdMode = useOmicronClientFlag('WEB_YANDEX_AD_MODE');
  const sspAdMode = useOmicronClientFlag('WEB_SSP_AD_MODE');
  const sspPartnerAdMode = useOmicronClientFlag('WEB_SSP_AD_PARTNER');
  const sspAdsAuthEnabled = useOmicronClientFlag('WEB_SSP_AD_WITH_AUTH');
  const sspScriptEnabled = useOmicronClientFlag('WEB_SSP_SCRIPT_ENABLED');
  const userInfo = useAuthorizedProfile();
  const [isSSpShown, setIsSSPShown] = useState(true);
  const [deviceType, setDeviceType] = useState<
    UAParser.IDevice['type'] | 'unknown'
  >('unknown');
  const env = useEnvConfig();
  const getPackageName = useGetCurrentAppPackageName();
  const getVkId = useGetVkId();
  const adFoxConfig = useOmicronClientFlag('ADFOX_CONFIG');
  const authProgressState = useAuthProgressState();
  const isAuthFinished = authDoneStates.includes(authProgressState);

  useEffect(() => {
    const parser = new UAParser(navigator.userAgent);
    setDeviceType(parser.getDevice()?.type);

    const sspUserId = safeLocalStorage.getItem(SSP_USER_ID) || v4();

    if (!safeLocalStorage.getItem(SSP_USER_ID)) {
      safeLocalStorage.setItem(SSP_USER_ID, sspUserId);
    }

    try {
      fetch(`https://ad.mail.ru/cm.gif?p=156&id=${sspUserId}`, {
        mode: 'no-cors',
      }).catch(console.warn);
    } catch (err) {
      console.warn('Ad pixel fetch failed', err);
    }
  }, []);

  const anySspEnabled =
    sspAdMode === 'ssp_floor_ad' ||
    sspAdMode === 'ssp_floor_ad_closed' ||
    sspPartnerAdMode === 'ssp_floor_ad_partner';

  if (anySspEnabled && isSSpShown) {
    const slotId = sspPartnerAdMode === 'ssp_floor_ad_partner' ? '9' : '1';
    const SSPAds = sspScriptEnabled ? ExternalSSP : SSP;

    if (sspAdsAuthEnabled) {
      return (
        <AuthDoneGate>
          <SSPAds
            setIsSSPShown={setIsSSPShown}
            slotId={slotId}
            isAuthFinished={isAuthFinished}
            logTmrEvent={logTmrEvent}
            emitYmEvent={emitYmEvent}
            SSP_SCRIPT_URL={getEnvConfig().SSP_SCRIPT_URL}
            SSP_URL={getEnvConfig().SSP_URL}
            sspAdsAuthEnabled={sspAdsAuthEnabled}
            userInfo={userInfo}
          />
        </AuthDoneGate>
      );
    }
    return (
      <SSPAds
        setIsSSPShown={setIsSSPShown}
        slotId={slotId}
        isAuthFinished={isAuthFinished}
        logTmrEvent={logTmrEvent}
        emitYmEvent={emitYmEvent}
        SSP_SCRIPT_URL={getEnvConfig().SSP_SCRIPT_URL}
        SSP_URL={getEnvConfig().SSP_URL}
        sspAdsAuthEnabled={sspAdsAuthEnabled}
        userInfo={userInfo}
      />
    );
  }

  if (yandexAdMode === 'floor_ad_banner') {
    if (deviceType === 'unknown') {
      return null;
    }
    return (
      <AuthDoneGate passIfAuthWasEverDone>
        {deviceType === 'mobile' ? (
          <YaMobileFloorBanner
            emitYmEvent={emitYmEvent}
            logTmrEvent={logTmrEvent}
            packageName={getPackageName()}
            vkId={getVkId()}
            adFoxConfig={adFoxConfig}
            YANDEX_ADS_FLOOR_AD_BANNER_ID={
              getEnvConfig().YANDEX_ADS_FLOOR_AD_BANNER_ID
            }
          />
        ) : (
          <YandexFloorAd
            mode="floor_ad_closed"
            env={env}
            analytics={{
              emitYmEvent: emitYmEvent,
              logTmrEvent: logTmrEvent,
              packageName: getPackageName(),
              vkId: getVkId(),
            }}
            config={adFoxConfig}
          />
        )}
      </AuthDoneGate>
    );
  }

  if (
    yandexAdMode === 'floor_ad' ||
    yandexAdMode === 'floor_ad_closed' ||
    yandexAdMode === 'floor_ad_closed_copy'
  ) {
    return (
      <AuthDoneGate passIfAuthWasEverDone>
        <YandexFloorAd
          mode={yandexAdMode}
          env={env}
          analytics={{
            emitYmEvent: emitYmEvent,
            logTmrEvent: logTmrEvent,
            packageName: getPackageName(),
            vkId: getVkId(),
          }}
          config={adFoxConfig}
        />
      </AuthDoneGate>
    );
  }

  return null;
};
